/* eslint-disable @typescript-eslint/no-explicit-any */
import React from "react";
import { IonApp, IonSpinner, setupIonicReact } from "@ionic/react";

/* Core CSS required for Ionic components to work properly */
import "@ionic/react/css/core.css";

/* Basic CSS for apps built with Ionic */
import "@ionic/react/css/normalize.css";
import "@ionic/react/css/structure.css";
import "@ionic/react/css/typography.css";

/* Optional CSS utils that can be commented out */
import "@ionic/react/css/padding.css";
import "@ionic/react/css/float-elements.css";
import "@ionic/react/css/text-alignment.css";
import "@ionic/react/css/text-transformation.css";
import "@ionic/react/css/flex-utils.css";
import "@ionic/react/css/display.css";

/* Parafolio component library required CSS */
import "parafolio-components/dist/style.css";

/* Theme variables */
import "./theme/variables.css";

import "./App.css";
import { RecoilRoot } from "recoil";
import { Suspense } from "react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import ParaFolio from "./ParaFolio";
import ErrorBoundaryFallback from "@pages/ErrorBoundaryFallback";
import { useFirebaseSetup } from "@hooks/app/useFirebaseSetup";
import { useGoogleVerification } from "@hooks/subscriptions/useGoogleVerification";
import { useAppLaunchSetup } from "@hooks/app/useAppLaunchSetup";
import RemoteDataController from "@controllers/RemoteDataController";
import * as Sentry from "@sentry/react";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
    },
  },
});

setupIonicReact({});

const App: React.FC = () => {
  useFirebaseSetup();
  useGoogleVerification();
  useAppLaunchSetup();

  return (
    <>
      <div className="app-color-overlay" />
      <QueryClientProvider client={queryClient}>
        <RecoilRoot>
          <IonApp>
            <Suspense
              fallback={
                <div className="loadingScreen">
                  <IonSpinner className="loadingScreenSpinner" />
                </div>
              }
            >
              <Sentry.ErrorBoundary
                fallback={({ error }) => <ErrorBoundaryFallback error={error} />}
                onError={(error) => {
                  RemoteDataController.logError(error as any);
                }}
              >
                <ParaFolio />
              </Sentry.ErrorBoundary>
            </Suspense>
          </IonApp>
        </RecoilRoot>
      </QueryClientProvider>
    </>
  );
};

export default App;
